<template>
  <div id="header-feedback">
    <el-popover
      v-model="visible"
      :popper-class="`header-feedback-popover ${isStage() ? 'stage-env' : ''}`"
      placement="bottom-end"
      trigger="click"
    >
      <div slot="reference" class="content">
        <img src="@/assets/icon-service.svg" class="icon" />
        <el-badge class="feedback-badge" :is-dot="isShowBadge">反馈</el-badge>
      </div>
      <div class="header-feedback-popover-content">
        <div class="item-wrapper" @click="goToFeedback">
          <img src="@/assets/icon-feedback.svg" class="icon" />
          <el-badge class="feedback-badge">问题反馈</el-badge>
        </div>
        <div class="item-wrapper" @click="goToEvaluation">
          <img src="@/assets/icon-evaluation.svg" class="icon" />
          <el-badge class="feedback-badge" :is-dot="isShowBadge">服务评价</el-badge>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { pushLXModuleClick, isStage } from '@/utils'

export default {
  name: 'HeaderFeedback',
  data() {
    return {
      isStage,
      visible: false,
      badge: {},
      cid: 'c_mobikeops_ydm7ii7m',
    }
  },

  computed: {
    isShowBadge() {
      return this.badge['evaluation-list']
    },
    misId() {
      return window.__BIKE_POLARIS__.mis
    },
  },

  mounted() {
    const _this = this
    const callback = function(event) {
      const { source, value } = event.data || {}
      if (source === 'PolarisBadge' || source === 'AssociateBadge') {
        _this.badge = value
      }
    }
    window.addEventListener('message', callback)
    this.$once('hook:beforeDestroy', function() {
      window.removeEventListener('message', callback)
    })
  },

  methods: {
    goToFeedback() {
      pushLXModuleClick(this.cid, 'b_mobikeops_unuotfgp_mc', this.misId)
      this.visible = false
      window.open('https://tt.sankuai.com/ticket/moses-helper?rgId=10604', '_blank')
    },
    goToEvaluation() {
      pushLXModuleClick(this.cid, 'b_mobikeops_zxzq7ajb_mc', this.misId)
      this.visible = false
      if (this.$route.path === '/service/evaluation-list') return
      this.$router.push('/service/evaluation-list')
    },
  },
}
</script>

<style scoped lang="scss">
#header-feedback {
  padding: 0 20px;
  color: rgba(255, 255, 255, 0.84);
  display: block;
  outline: none;
  font-size: 14px;
  .el-popover__reference-wrapper {
    .content {
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
    }
    .icon {
      margin-right: 8px;
      font-size: 20px;
    }
  }
}
</style>

<style lang="scss">
.header-feedback-popover {
  min-width: 108px !important;
  width: 108px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px !important;
  top: 40px !important;
  &.stage-env {
    top: 80px !important;
  }
  &-content {
    display: flex;
    flex-direction: column;
    .item-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 7px 8px;
      cursor: pointer;
      font-size: 14px;
    }
    .icon {
      margin-right: 6px;
      font-size: 16px;
    }
  }
}
.feedback-badge {
  font-size: 14px;
  .el-badge__content {
    background-color: #ff1f1f;
    border: none;
    &.is-dot {
      width: 6px;
      height: 6px;
    }
    &.is-fixed.is-dot {
      top: 4px;
      left: -14px;
    }
  }
}
</style>
